export default "__VITE_ASSET__CODrJaJW__"